import { ComponentCtaButtonColor } from '../../../lib/types'
import { ButtonColor } from '../../ui-lib/button'

export const getButtonColor = (colorInfo: ComponentCtaButtonColor) => {
  switch (colorInfo) {
    case ComponentCtaButtonColor.WDK24PrimaryLightBg:
      return ButtonColor.WDK24PrimaryLightBg
    case ComponentCtaButtonColor.WDK24SecondaryLightBg:
      return ButtonColor.WDK24SecondaryLightBg
    case ComponentCtaButtonColor.WDK24TertiaryLightBg:
      return ButtonColor.WDK24TertiaryLightBg
    case ComponentCtaButtonColor.WDK24PrimaryDarkBg:
      return ButtonColor.WDK24PrimaryDarkBg
    case ComponentCtaButtonColor.WDK24SecondaryDarkBg:
      return ButtonColor.WDK24SecondaryDarkBg
    case ComponentCtaButtonColor.WDK24TertiaryDarkBg:
      return ButtonColor.WDK24TertiaryDarkBg
    case ComponentCtaButtonColor.WDK24LimeGreenDarkBg:
      return ButtonColor.WDK24LimeGreenDarkBg
    case ComponentCtaButtonColor.WDK24LimeGreenBlackTextDarkBg:
      return ButtonColor.WDK24LimeGreenBlackTextDarkBg
    case ComponentCtaButtonColor.WDK24GoogleSecondaryDarkBg:
      return ButtonColor.WDK24GoogleSecondaryDarkBg
    case ComponentCtaButtonColor.WDK24BlackWhiteText:
      return ButtonColor.WDK24BlackWhiteText
    case ComponentCtaButtonColor.WhiteTextGreenButton:
      return ButtonColor.PrimaryGreen
    case ComponentCtaButtonColor.WDK24WhiteBlackText:
      return ButtonColor.WDK24WhiteBlackText
    case ComponentCtaButtonColor.PrimaryDarkBg:
      return ButtonColor.PrimaryOnDarkBg
    case ComponentCtaButtonColor.Secondary:
      return ButtonColor.Secondary
    case ComponentCtaButtonColor.SecondaryDarkBg:
      return ButtonColor.SecondaryOnDarkBg
    case ComponentCtaButtonColor.Tertiary:
      return ButtonColor.Tertiary
    case ComponentCtaButtonColor.GoPrimaryDarkBg:
      return ButtonColor.GoPrimaryOnDarkBg
    case ComponentCtaButtonColor.GoSecondaryDarkBg:
      return ButtonColor.GoSecondaryOnDarkBg
    // The following buttons will be deprecated
    case ComponentCtaButtonColor.GreenTextGreyButton:
      return ButtonColor.SecondaryGreen
    case ComponentCtaButtonColor.WhiteTextBlueButton:
      return ButtonColor.PrimaryBlue
    case ComponentCtaButtonColor.BlueTextGreyButton:
      return ButtonColor.SecondaryBlue
    // This is added for the anonymous free trial experiment to allow the button to be unstyled
    case ComponentCtaButtonColor.UnstyledButton:
      return undefined

    default:
      return ButtonColor.Transparent
  }
}
